/* eslint-disable use-isnan */
import React, { useState, useEffect } from 'react';
import Button from '../../Subcomponents/Button';
import cssClasses from './SelectInventory.module.css';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Wings from '../../Subcomponents/Wings';
import { Box } from '@mui/system';
import { Checkbox, Grid } from '@mui/material';
import Units from '../../Subcomponents/Units';
import DropDown from '../../Subcomponents/DropDown';
import { isEqual, sortBy } from 'lodash';
import { errorTost } from '../../Services/Toast';
import { useSelector } from 'react-redux';

export default function SelectInventory({
  selectedLaunch,
  setTotalUnitsSelected,
  flag = '',
  setFlag,
  setTotalFloorsSelected,
  allChildInventory,
  setAllChildInventory,
  allInventory,
  showMergeBtn = true,
  allUnitsToMerge,
  setOpenAlert,
  totalFloorsSelected,
  totalUnitsSelected,
  mode,
  unitsToMerge,
  showMerge,
  setShowMerge,
  setUnitsToMerge,
}) {
  console.log('allChildInventory: ', allChildInventory);

  const [showWings, setShowWings] = useState(mode === 'edit' ? false : true);
  const [showUnits, setShowUnits] = useState('');
  const [selectedWing, setSelectedWing] = useState('');
  const [unit1, setUnit1] = useState(null);
  const [unit2, setUnit2] = useState(null);
  console.log(showWings);
  const farvisionStatusOpt = [
    {
      label: 'Available',
      value: 'Available',
    },
    {
      label: 'Hold',
      value: 'Hold',
    },
    {
      label: 'Blocked',
      value: 'Blocked',
    },
    {
      label: 'Booked',
      value: 'Booked',
    },
    {
      label: 'All',
      value: 'All',
    },
  ];
  const [selectedFVStatus, setSelectedFVStatus] = useState('All');
  let loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  useEffect(() => {
    if (mode === 'edit' && allChildInventory.length === 0) {
      setShowUnits('');
      setSelectedWing('');
      setShowWings(false);
      if (setTotalUnitsSelected) {
        setTotalUnitsSelected(0);
        setTotalFloorsSelected(0);
      }
    }
  }, [selectedLaunch, allChildInventory]);

  useEffect(() => {
    console.log('unit1', unit1);
    console.log('unit2', unit2);
  }, [unit1, unit2]);

  useEffect(() => {
    if (Object.keys(allChildInventory).length > 0) {
      for (let i = 0; i < Object.keys(allChildInventory).length; i++) {
        if (
          allChildInventory[Object.keys(allChildInventory)[i]].isSelected ===
          true
        ) {
          setSelectedWing(Object.keys(allChildInventory)[i]);
          break;
        }
      }
    } else {
      setSelectedWing('');
    }
    // setSelectedWing(Object.keys(allChildInventory).length > 0 ? Object.keys(allChildInventory)[0] : '')
  }, [showMerge]);

  useEffect(() => {
    setUnit1(null);
    setUnit2(null);
  }, [selectedWing]);

  useEffect(() => {
    if (flag === 'change') {
      setShowWings(false);
    }
  }, [flag]);

  return (
    <div>
      {!showMerge ? (
        <div className={cssClasses.mainContainer}>
          <div className={cssClasses.header}>
            <div style={{ display: 'flex' }}>
              {(showWings || showUnits) && (
                <Button
                  clicked={() => {
                    if (mode === 'edit') {
                      if (showUnits !== '') {
                        setShowWings(true);
                        setShowUnits('');
                      } else {
                        if (setFlag) {
                          setFlag('change');
                        }
                        setShowWings(false);
                      }
                    } else {
                      setShowUnits(' ');
                      setShowWings(true);
                    }
                  }}
                  btnName={
                    mode === 'edit' ? 'Select Inventory' : 'Preview Inventory'
                  }
                  style={{
                    borderRadius: '0.4rem',
                    boxShadow: 'none',
                    backgroundColor: '#ffffff',
                    color: '#667085',
                    fontSize: '1.6rem',
                    border: 'none',
                  }}
                  padding={'0.5rem 1rem'}
                  iconPosition={'left'}
                  btnIcon={
                    <KeyboardBackspaceIcon
                      style={{ width: '2rem', height: '2rem' }}
                      color='#667085'
                    />
                  }
                />
              )}
            </div>
            <div className={cssClasses.countWrapper}>
              <div className={cssClasses.countWrapperChild}>
                <div>
                  <p className={cssClasses.label}>
                    Wings Selected :{' '}
                    {
                      Object.keys(allChildInventory).filter((e) => {
                        return allChildInventory[e].isSelected === true;
                      }).length
                    }
                  </p>
                </div>
                <div>
                  <p className={cssClasses.label}>
                    Floors Selected : {totalFloorsSelected}
                  </p>
                </div>
                <div>
                  <p className={cssClasses.label}>
                    Units Selected : {totalUnitsSelected}
                  </p>
                </div>
              </div>
              <div>
                {!showWings && showUnits === '' && mode === 'edit' && (
                  // ! show 'Edit' & 'Merge' buttons

                  <div className={cssClasses.btnWrapper}>
                    {loggedInUser?.roleId?.accessibleTabs?.Project?.[
                      'View Project Details'
                    ]?.Inventory?.Edit?.isAccessible && (
                        <div>
                          <Button
                            clicked={() => {
                              setShowWings(true);
                              if (flag !== '') {
                                setFlag('hide preview');
                              }
                              console.log('clicked');
                            }}
                            btnName={'Edit'}
                            style={{
                              borderRadius: '0.4rem',
                              backgroundColor: '#1570EF',
                              color: '#FFFFFF',
                              fontSize: '1.6rem',
                            }}
                            padding={'0.5rem 1rem'}
                            iconPosition={'right'}
                            btnIcon={<EditOutlinedIcon color='white' />}
                          />
                        </div>
                      )}
                    {showMergeBtn &&
                      loggedInUser?.roleId?.accessibleTabs?.Project?.[
                        'View Project Details'
                      ]?.Inventory?.Merge?.isAccessible && (
                        <div>
                          <Button
                            clicked={() => {
                              if (flag !== '') {
                                setFlag('hide preview');
                              }
                              setUnit1(null);
                              setUnit2(null);
                              if (
                                Object.keys(allInventory).filter((e) => {
                                  return allInventory[e].isSelected === true;
                                }).length > 0
                              ) {
                                setShowMerge(true);
                              } else {
                                errorTost(
                                  'Please select and save inventory to merge'
                                );
                              }
                            }}
                            btnName={'Merge'}
                            style={{
                              borderRadius: '0.4rem',
                              backgroundColor: '#FFFFFF',
                              color: '#1570EF',
                              fontSize: '1.6rem',
                              border: '1px solid #1570EF',
                            }}
                            padding={'0.5rem 1rem'}
                            iconPosition={'right'}
                            btnIcon={<ExtensionOutlinedIcon color='white' />}
                          />
                        </div>
                      )}
                  </div>
                )}
                {!showWings && showUnits !== '' && mode === 'edit' && (
                  //  ! filters for farvision status
                  <div className={cssClasses.btnWrapper}>
                    <div className={cssClasses.filterTitle}>Filter by</div>
                    <div className={cssClasses.filterDropdown}>
                      <DropDown
                        list={farvisionStatusOpt}
                        selectedValue={selectedFVStatus}
                        onChangeSelect={(value) => {
                          setSelectedFVStatus(value);
                          console.log(
                            'allChildInventory[showUnits]',
                            allChildInventory[showUnits]
                          );
                          Object.keys(
                            allChildInventory[showUnits].floors
                          ).forEach((floor) => {
                            allChildInventory[showUnits].floors[
                              floor
                            ].units.forEach((unit) => {
                              unit.show =
                                value === 'All' ? true : unit.farvisionStatus === value ? true : false;
                            });
                          });
                        }}
                        placeHolder={''}
                        style={{
                          background: '#F2F4F7',
                          color: 'rgb(102, 112, 133)',
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={cssClasses.content}>
            {showWings && (
              <div style={{ marginTop: '2.3rem' }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid
                    container
                    spacing={{ xs: 2, md: 3, lg: 3 }}
                    columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}
                  >
                    {Object.keys(allChildInventory).map((m) => {
                      if (
                        allChildInventory[m].isSelected === true &&
                        mode === 'preview'
                      ) {
                        return (
                          <Wings
                            wingName={m}
                            isSelected={allChildInventory[m].isSelected}
                            showCheckbox={false}
                            changeWingStatus={() => {
                              setAllChildInventory((pre) => {
                                if (pre[m].isSelected === true) {
                                  pre[m].isSelected = false;
                                  Object.keys(pre[m].floors).forEach((ele) => {
                                    pre[m].floors[ele].isSelected = false;
                                    pre[m].floors[ele].units.forEach((e) => {
                                      e.isSelected = false;
                                    });
                                  });
                                } else {
                                  pre[m].isSelected = true;
                                  Object.keys(pre[m].floors).forEach((ele) => {
                                    pre[m].floors[ele].isSelected = true;
                                    pre[m].floors[ele].units.forEach((e) => {
                                      e.isSelected = true;
                                    });
                                  });
                                }
                                return { ...pre };
                              });
                            }}
                            arrowClicked={() => {
                              setShowWings(false);
                              setShowUnits(m);
                            }}
                          />
                        );
                      } else if (mode === 'edit') {
                        return (
                          <Wings
                            wingName={m}
                            isSelected={allChildInventory[m].isSelected}
                            showCheckbox={true}
                            changeWingStatus={() => {
                              setAllChildInventory((pre) => {
                                if (pre[m].isSelected === true) {
                                  pre[m].isSelected = false;
                                  Object.keys(pre[m].floors).forEach((ele) => {
                                    pre[m].floors[ele].isSelected = false;
                                    pre[m].floors[ele].units.forEach((e) => {
                                      e.isSelected = false;
                                    });
                                  });
                                } else {
                                  Object.keys(pre[m].floors).forEach((ele) => {
                                    pre[m].floors[ele].units.forEach((e) => {
                                      if (
                                        e.farvisionStatus !== 'Booked' &&
                                        e.farvisionStatus !== 'Blocked'
                                      ) {
                                        e.isSelected = true;
                                      }
                                    });
                                    if (
                                      pre[m].floors[ele].units.filter((e) => {
                                        return e.isSelected;
                                      }).length > 0
                                    ) {
                                      pre[m].floors[ele].isSelected = true;
                                    }
                                  });
                                  if (
                                    Object.keys(pre[m].floors).filter((e) => {
                                      return pre[m].floors[e].isSelected;
                                    }).length > 0
                                  ) {
                                    pre[m].isSelected = true;
                                  } else {
                                    errorTost(
                                      'Cannot select this wing as all units in this wing are booked or blocked'
                                    );
                                  }
                                }
                                return { ...pre };
                              });
                            }}
                            arrowClicked={() => {
                              setShowWings(false);
                              setShowUnits(m);
                            }}
                          />
                        );
                      }
                    })}
                  </Grid>
                </Box>
              </div>
            )}
            {showUnits !== '' && allChildInventory[showUnits] && (
              <div>
                <div className={cssClasses.floors}>
                  <p
                    className={cssClasses.floorNo}
                    style={{ textAlign: 'center' }}
                  >
                    Floor
                  </p>
                </div>
                <div className={cssClasses.heightBox}>
                  {sortBy(
                    Object.keys(allChildInventory[showUnits].floors),
                    (fl) => {
                      return isNaN(parseInt(fl.split(' ')[1]))
                        ? 0
                        : parseInt(fl.split(' ')[1]);
                    }
                  ).map((m) => (
                    <div className={cssClasses.floorWrapper}>
                      <div className={cssClasses.floorHeader}>
                        <div
                          className={cssClasses.floorNo}
                          style={{ width: '25%' }}
                        >
                          {allChildInventory[showUnits].floors[m].units.filter(
                            (e) => {
                              return e.show;
                            }
                          ).length > 0 && (
                              <p>
                                Units Selected :{' '}
                                {
                                  allChildInventory[showUnits].floors[
                                    m
                                  ].units.filter((e) => {
                                    return e.isSelected === true;
                                  }).length
                                }
                              </p>
                            )}
                        </div>
                        <div style={{ width: '50%', textAlign: 'center' }}>
                          <p className={cssClasses.floorNo}>
                            {m}
                            {/* {m % 10 === 1 &&
                                                        <span>st</span>
                                                    }
                                                    {m % 10 === 2 &&
                                                        <span>nd</span>
                                                    }
                                                    {m % 10 === 3 &&
                                                        <span>rd</span>
                                                    }
                                                    {m % 10 > 3 &&
                                                        <span>th</span>
                                                    } */}
                          </p>
                        </div>
                        <div
                          className={cssClasses.btnWrapper}
                          style={{ width: '25%', justifyContent: 'flex-end' }}
                        >
                          {allChildInventory[showUnits].floors[m].units.filter(
                            (e) => {
                              return (
                                e.show &&
                                e.farvisionStatus !== 'Booked' &&
                                e.farvisionStatus !== 'Blocked'
                              );
                            }
                          ).length > 0 && (
                              <>
                                {mode === 'edit' && (
                                  <div
                                    className={cssClasses.floorNo}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <p>Deselect All</p>
                                    <Checkbox
                                      onChange={() => {
                                        setAllChildInventory((pre) => {
                                          pre[showUnits].floors[m].units.forEach(
                                            (e) => {
                                              if (showMergeBtn) {
                                                if (!e.inventoryMergeId) {
                                                  e.isSelected = false;
                                                }
                                              } else {
                                                e.isSelected = false;
                                              }
                                            }
                                          );
                                          if (
                                            pre[showUnits].floors[m].units
                                              .length ===
                                            pre[showUnits].floors[m].units.filter(
                                              (e) => {
                                                return e.isSelected === false;
                                              }
                                            ).length
                                          ) {
                                            pre[showUnits].floors[
                                              m
                                            ].isSelected = false;
                                          }
                                          if (
                                            Object.keys(pre[showUnits].floors)
                                              .length ===
                                            Object.keys(
                                              pre[showUnits].floors
                                            ).filter((e) => {
                                              return (
                                                pre[showUnits].floors[e]
                                                  .isSelected === false
                                              );
                                            }).length
                                          ) {
                                            pre[showUnits].isSelected = false;
                                          }
                                          return { ...pre };
                                        });
                                      }}
                                      checked={
                                        allChildInventory[showUnits].floors[m]
                                          .units.length ===
                                        allChildInventory[showUnits].floors[
                                          m
                                        ].units.filter((e) => {
                                          return e.isSelected === false;
                                        }).length
                                      }
                                    />
                                  </div>
                                )}
                                {mode === 'edit' && (
                                  <div
                                    className={cssClasses.floorNo}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <p>Select All</p>
                                    <Checkbox
                                      onChange={() => {
                                        setAllChildInventory((pre) => {
                                          pre[showUnits].floors[m].units.forEach(
                                            (e) => {
                                              if (
                                                e.farvisionStatus !== 'Booked' &&
                                                e.farvisionStatus !== 'Blocked'
                                              ) {
                                                e.isSelected = true;
                                              }
                                            }
                                          );
                                          if (
                                            pre[showUnits].floors[m].units.filter(
                                              (e) => {
                                                return e.isSelected;
                                              }
                                            ).length > 0
                                          ) {
                                            pre[showUnits].floors[
                                              m
                                            ].isSelected = true;
                                            // if (Object.keys(pre[showUnits].floors).length === Object.keys(pre[showUnits].floors).filter((e) => { return pre[showUnits].floors[e].isSelected === true }).length) {
                                            pre[showUnits].isSelected = true;
                                            // }
                                          }
                                          return { ...pre };
                                        });
                                      }}
                                      checked={
                                        allChildInventory[showUnits].floors[
                                          m
                                        ].units.filter((e) => {
                                          return (
                                            e.farvisionStatus !== 'Booked' &&
                                            e.farvisionStatus !== 'Blocked'
                                          );
                                        }).length ===
                                        allChildInventory[showUnits].floors[
                                          m
                                        ].units.filter((e) => {
                                          return e.isSelected === true;
                                        }).length
                                      }
                                    />
                                  </div>
                                )}
                              </>
                            )}
                        </div>
                      </div>
                      <div style={{ padding: '0 1rem' }}>
                        {allChildInventory[showUnits].floors[m].units.filter(
                          (e) => {
                            return e.show;
                          }
                        ).length > 0 ? (
                          <Box sx={{ flexGrow: 1 }}>
                            <Grid
                              alignItems={'stretch'}
                              container
                              spacing={{ xs: 2, md: 3, lg: 3 }}
                              columns={{ xs: 2, sm: 4, md: 4, lg: 6 }}
                            >
                              {allChildInventory[showUnits].floors[m].units.map(
                                (element, index) => {
                                  if (
                                    element.isSelected === true &&
                                    mode === 'preview'
                                  ) {
                                    return (
                                      <Units
                                        showCheckbox={() => {
                                          return false;
                                        }}
                                        unit={element}
                                        style={
                                          element.isSelected === true
                                            ? { background: '#F2F4F7' }
                                            : null
                                        }
                                        changeUnitStatus={(e) => {
                                          setAllChildInventory((pre) => {
                                            if (
                                              pre[showUnits].floors[m].units[
                                                index
                                              ].isSelected === true
                                            ) {
                                              pre[showUnits].floors[m].units[
                                                index
                                              ].isSelected = false;
                                              if (
                                                pre[showUnits].floors[m].units
                                                  .length ===
                                                pre[showUnits].floors[
                                                  m
                                                ].units.filter((e) => {
                                                  return e.isSelected === false;
                                                }).length
                                              ) {
                                                pre[showUnits].floors[
                                                  m
                                                ].isSelected = false;
                                              }
                                              if (
                                                Object.keys(
                                                  pre[showUnits].floors
                                                ).length ===
                                                Object.keys(
                                                  pre[showUnits].floors
                                                ).filter((e) => {
                                                  return (
                                                    pre[showUnits].floors[e]
                                                      .isSelected === false
                                                  );
                                                }).length
                                              ) {
                                                pre[
                                                  showUnits
                                                ].isSelected = false;
                                              }
                                            } else {
                                              pre[showUnits].floors[m].units[
                                                index
                                              ].isSelected = true;
                                              pre[showUnits].floors[
                                                m
                                              ].isSelected = true;
                                              pre[showUnits].isSelected = true;
                                            }
                                            return { ...pre };
                                          });
                                        }}
                                        paired={
                                          unitsToMerge.filter((e) => {
                                            return (
                                              e.unit1Id === element.unitId ||
                                              e.unit2Id === element.unitId
                                            );
                                          }).length > 0
                                            ? true
                                            : false
                                        }
                                        pairedInfo={() => {
                                          if (
                                            unitsToMerge.filter((e) => {
                                              return (
                                                e.unit1Id === element.unitId ||
                                                e.unit2Id === element.unitId
                                              );
                                            })[0].unit1Id === element.unitId
                                          ) {
                                            return `Paired with ${unitsToMerge.filter((e) => {
                                              return (
                                                e.unit1Id ===
                                                element.unitId ||
                                                e.unit2Id === element.unitId
                                              );
                                            })[0].unit2No
                                              } `;
                                          } else {
                                            return `Paired with ${unitsToMerge.filter((e) => {
                                              return (
                                                e.unit1Id ===
                                                element.unitId ||
                                                e.unit2Id === element.unitId
                                              );
                                            })[0].unit1No
                                              } `;
                                          }
                                        }}
                                      />
                                    );
                                  } else if (mode === 'edit' && element.show) {
                                    return (
                                      <Units
                                        showCheckbox={() => {
                                          if (
                                            (element.inventoryMergeId &&
                                              element.inventoryMergeId !== '' &&
                                              showMergeBtn) ||
                                            ((element.farvisionStatus ===
                                              'Booked' ||
                                              element.farvisionStatus ===
                                              'Blocked') && !element.isSelected || element.LaunchInventoryRelations?.length > 0 )
                                          ) {
                                            return false;
                                          } else {
                                            return true;
                                          }
                                        }}
                                        farvisionStatus={true}
                                        showPrice={true}
                                        unit={element}
                                        style={
                                          element.isSelected === true
                                            ? { background: '#F2F4F7' }
                                            : null
                                        }
                                        changeUnitStatus={(e) => {
                                          setAllChildInventory((pre) => {
                                            if (
                                              pre[showUnits].floors[m].units[
                                                index
                                              ].isSelected === true
                                            ) {
                                              pre[showUnits].floors[m].units[
                                                index
                                              ].isSelected = false;
                                              if (
                                                pre[showUnits].floors[m].units[
                                                  index
                                                ].inventoryMergeId
                                              ) {
                                                Object.keys(
                                                  pre[showUnits].floors
                                                ).forEach((ele) => {
                                                  pre[showUnits].floors[
                                                    ele
                                                  ].units.forEach((units) => {
                                                    if (
                                                      units.unitId ===
                                                      pre[showUnits].floors[m]
                                                        .units[index]
                                                        .inventoryMergeId
                                                        .unit1Id ||
                                                      units.unitId ===
                                                      pre[showUnits].floors[m]
                                                        .units[index]
                                                        .inventoryMergeId
                                                        .unit2Id
                                                    ) {
                                                      units.isSelected = false;
                                                    }
                                                  });
                                                });
                                              }
                                              if (
                                                pre[showUnits].floors[m].units
                                                  .length ===
                                                pre[showUnits].floors[
                                                  m
                                                ].units.filter((e) => {
                                                  return e.isSelected === false;
                                                }).length
                                              ) {
                                                pre[showUnits].floors[
                                                  m
                                                ].isSelected = false;
                                              }
                                              if (
                                                Object.keys(
                                                  pre[showUnits].floors
                                                ).length ===
                                                Object.keys(
                                                  pre[showUnits].floors
                                                ).filter((e) => {
                                                  return (
                                                    pre[showUnits].floors[e]
                                                      .isSelected === false
                                                  );
                                                }).length
                                              ) {
                                                pre[
                                                  showUnits
                                                ].isSelected = false;
                                              }
                                            } else {
                                              if (
                                                pre[showUnits].floors[m].units[
                                                  index
                                                ].inventoryMergeId
                                              ) {
                                                Object.keys(
                                                  pre[showUnits].floors
                                                ).forEach((ele) => {
                                                  pre[showUnits].floors[
                                                    ele
                                                  ].units.forEach((units) => {
                                                    if (
                                                      units.unitId ===
                                                      pre[showUnits].floors[m]
                                                        .units[index]
                                                        .inventoryMergeId
                                                        .unit1Id ||
                                                      units.unitId ===
                                                      pre[showUnits].floors[m]
                                                        .units[index]
                                                        .inventoryMergeId
                                                        .unit2Id
                                                    ) {
                                                      units.isSelected = true;
                                                    }
                                                  });
                                                });
                                              }
                                              pre[showUnits].floors[m].units[
                                                index
                                              ].isSelected = true;
                                              pre[showUnits].floors[
                                                m
                                              ].isSelected = true;
                                              pre[showUnits].isSelected = true;
                                            }
                                            return { ...pre };
                                          });
                                        }}
                                        paired={
                                          unitsToMerge.filter((e) => {
                                            return (
                                              e.unit1Id === element.unitId ||
                                              e.unit2Id === element.unitId
                                            );
                                          }).length > 0
                                            ? true
                                            : false
                                        }
                                        pairedInfo={() => {
                                          if (
                                            unitsToMerge.filter((e) => {
                                              return (
                                                e.unit1Id === element.unitId ||
                                                e.unit2Id === element.unitId
                                              );
                                            })[0].unit1Id === element.unitId
                                          ) {
                                            return `Paired with ${unitsToMerge.filter((e) => {
                                              return (
                                                e.unit1Id ===
                                                element.unitId ||
                                                e.unit2Id === element.unitId
                                              );
                                            })[0].unit2No
                                              } `;
                                          } else {
                                            return `Paired with ${unitsToMerge.filter((e) => {
                                              return (
                                                e.unit1Id ===
                                                element.unitId ||
                                                e.unit2Id === element.unitId
                                              );
                                            })[0].unit1No
                                              } `;
                                          }
                                        }}
                                      />
                                    );
                                  }
                                }
                              )}
                            </Grid>
                          </Box>
                        ) : (
                          <p
                            style={{
                              textAlign: 'center',
                              fontSize: '1.4rem',
                            }}
                          >
                            No Data Available
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={cssClasses.mainContainer}>
          <div className={cssClasses.mergeHeader}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <Button
                  clicked={() => {
                    if (!isEqual(allUnitsToMerge, unitsToMerge)) {
                      setOpenAlert(true);
                    } else {
                      setShowMerge(false);
                      if (flag !== '') {
                        setFlag('change');
                      }
                      // setCreateLaunch((pre) => { pre.timeline[4].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
                    }
                  }}
                  btnName={'Select Inventory'}
                  style={{
                    borderRadius: '0.4rem',
                    boxShadow: 'none',
                    backgroundColor: '#ffffff',
                    color: '#667085',
                    fontSize: '1.6rem',
                    border: 'none',
                  }}
                  padding={'0.5rem 1rem'}
                  iconPosition={'left'}
                  btnIcon={
                    <KeyboardBackspaceIcon
                      style={{ width: '2rem', height: '2rem' }}
                      color='#667085'
                    />
                  }
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: '5rem',
                  alignItems: 'center',
                }}
              >
                <div>
                  <div>
                    <DropDown
                      label={'Select Wing'}
                      list={Object.keys(allChildInventory).filter((m) => {
                        return allChildInventory[m].isSelected === true;
                      })}
                      selectedValue={selectedWing}
                      onChangeSelect={(e) => {
                        setSelectedWing(e);
                      }}
                    />
                  </div>
                </div>
                <div>
                  {unit1 && unit2 && (
                    <Button
                      clicked={() => {
                        let arr =
                          unitsToMerge?.length > 0 ? [...unitsToMerge] : [];
                        arr.push({
                          unit1Id: unit1.unitId,
                          unit2Id: unit2.unitId,
                          unit1No: unit1.unitNo,
                          unit2No: unit2.unitNo,
                        });
                        setUnitsToMerge([...arr]);
                        setUnit1(null);
                        setUnit2(null);
                      }}
                      btnName={'Merge Selected Units'}
                      style={{
                        borderRadius: '0.4rem',
                        boxShadow: 'none',
                        backgroundColor: 'rgb(21, 112, 239)',
                        color: 'rgb(255, 255, 255)',
                        fontSize: '1.6rem',
                        border: 'none',
                      }}
                      padding={'0.5rem 1rem'}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            className={cssClasses.content}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '2rem',
              overflowY: 'auto',
            }}
          >
            <div style={{ width: '100%' }}>
              {selectedWing !== '' ? (
                <>
                  {Object.keys(allChildInventory[selectedWing].floors)
                    .filter((e) => {
                      return (
                        allChildInventory[selectedWing].floors[e].units.filter(
                          (ele) => {
                            return ele.isSelected === true;
                          }
                        ).length > 0
                      );
                    })
                    .map((floor) => (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '2rem',
                          marginBottom: '1rem',
                        }}
                      >
                        <div
                          style={{
                            width: '5rem',
                            background: '#D0D5DD',
                            height: '12rem',
                            position: 'relative',
                            borderRadius: '0.5rem',
                          }}
                        >
                          <p
                            style={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              fontSize: '1.4rem',
                            }}
                          >
                            {floor}
                          </p>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1rem',
                            width: '93%',
                          }}
                        >
                          {allChildInventory[selectedWing].floors[floor].units
                            .filter((e) => {
                              return e.isSelected === true;
                            })
                            .map((unit) => (
                              <Units
                                setUnitsToMerge={setUnitsToMerge}
                                unitsToMerge={unitsToMerge}
                                showCheckbox={() => {
                                  if (
                                    unitsToMerge?.filter((e) => {
                                      return (
                                        e.unit1Id === unit.unitId ||
                                        e.unit2Id === unit.unitId
                                      );
                                    }).length > 0
                                  ) {
                                    return false;
                                  } else {
                                    if (
                                      allChildInventory[selectedWing].floors[
                                        floor
                                      ].isSelected === true &&
                                      allChildInventory[selectedWing].floors[
                                        floor
                                      ].units.length > 0
                                    ) {
                                      if (unit1 && unit2) {
                                        if (
                                          unit.unitId === unit1.unitId ||
                                          unit.unitId === unit2.unitId
                                        ) {
                                          return true;
                                        } else {
                                          return false;
                                        }
                                      } else if (unit1 && !unit2) {
                                        if (
                                          unit1.unitId === unit.unitId ||
                                          parseInt(unit.unitNo) ===
                                          parseInt(unit1.unitNo) + 100 ||
                                          parseInt(unit.unitNo) ===
                                          parseInt(unit1.unitNo) - 100 ||
                                          parseInt(unit.unitNo) ===
                                          parseInt(unit1.unitNo) + 1 ||
                                          parseInt(unit.unitNo) ===
                                          parseInt(unit1.unitNo) - 1
                                        ) {
                                          return true;
                                        } else {
                                          return false;
                                        }
                                      } else if (!unit1 && unit2) {
                                        if (
                                          unit2.unitId === unit.unitId ||
                                          parseInt(unit.unitNo) ===
                                          parseInt(unit2.unitNo) + 100 ||
                                          parseInt(unit.unitNo) ===
                                          parseInt(unit2.unitNo) - 100 ||
                                          parseInt(unit.unitNo) ===
                                          parseInt(unit2.unitNo) + 1 ||
                                          parseInt(unit.unitNo) ===
                                          parseInt(unit2.unitNo) - 1
                                        ) {
                                          return true;
                                        } else {
                                          return false;
                                        }
                                      } else {
                                        return true;
                                      }
                                    } else {
                                      return false;
                                    }
                                  }
                                }}
                                changeUnitStatus={(e) => {
                                  if (e.target.checked) {
                                    if (!unit1) {
                                      setUnit1(unit);
                                    } else {
                                      setUnit2(unit);
                                    }
                                  } else {
                                    if (unit1?.unitId === unit.unitId) {
                                      setUnit1(null);
                                    } else {
                                      setUnit2(null);
                                    }
                                  }
                                }}
                                paired={
                                  unitsToMerge.filter((e) => {
                                    return (
                                      e.unit1Id === unit.unitId ||
                                      e.unit2Id === unit.unitId
                                    );
                                  }).length > 0
                                    ? true
                                    : false
                                }
                                pairedInfo={() => {
                                  if (
                                    unitsToMerge.filter((e) => {
                                      return (
                                        e.unit1Id === unit.unitId ||
                                        e.unit2Id === unit.unitId
                                      );
                                    })[0].unit1Id === unit.unitId
                                  ) {
                                    return `Paired with ${unitsToMerge.filter((e) => {
                                      return (
                                        e.unit1Id === unit.unitId ||
                                        e.unit2Id === unit.unitId
                                      );
                                    })[0].unit2No
                                      } `;
                                  } else {
                                    return `Paired with ${unitsToMerge.filter((e) => {
                                      return (
                                        e.unit1Id === unit.unitId ||
                                        e.unit2Id === unit.unitId
                                      );
                                    })[0].unit1No
                                      } `;
                                  }
                                }}
                                unit={unit}
                                merge={true}
                              />
                            ))}
                        </div>
                      </div>
                    ))}
                </>
              ) : (
                <>Please Select a Wing</>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
